import clsx from 'clsx';
import type { LottieRef } from 'lottie-react';
import { useEffect, useRef, useState } from 'react';

import { LazyLottie } from './lazy-lottie';
import * as styles from './styles.css';

const loadAnimation = () => import('./collections-icon.json');

export interface CollectionsIconProps {
  closed: boolean; // eg, when collections icon is a "dragged over" state
  className?: string;
}

// animated collections icon that has two states: closed and opened
export const AnimatedCollectionsIcon = ({
  closed,
  className,
}: CollectionsIconProps) => {
  const lottieRef: LottieRef = useRef(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (ready && lottieRef.current) {
      const lottie = lottieRef.current;
      if (closed) {
        lottie.setDirection(1);
      } else {
        lottie.setDirection(-1);
      }
      lottie.play();
    }
  }, [closed, ready]);

  return (
    <LazyLottie
      className={clsx(styles.root, className)}
      autoPlay={false}
      loop={false}
      lottieRef={lottieRef}
      load={loadAnimation}
      onDOMLoaded={() => setReady(true)}
    />
  );
};
